import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;
const ENCRYPTION_KEY = SECRET_KEY;

export const encryptData = (data) => {
  if (!data) {
    return '';
  }
  return CryptoJS.AES.encrypt(data.toString(), ENCRYPTION_KEY).toString();
};

export const decryptData = (encryptedData) => {
  if (!encryptedData) {
    return '';
  }
  const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedData;
};
